/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ task: NonNullable<unknown> }} Notifications_Task_Sla_Breach_TitleInputs */

const en_notifications_task_sla_breach_title = /** @type {(inputs: Notifications_Task_Sla_Breach_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Task overdue: ${i?.task}`)
};

const pt_br2_notifications_task_sla_breach_title = /** @type {(inputs: Notifications_Task_Sla_Breach_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atividade atrasada: ${i?.task}`)
};

/**
* | output |
* | --- |
* | "Task overdue: {task}" |
*
* @param {Notifications_Task_Sla_Breach_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_task_sla_breach_title = /** @type {((inputs: Notifications_Task_Sla_Breach_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Task_Sla_Breach_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_task_sla_breach_title(inputs)
	return pt_br2_notifications_task_sla_breach_title(inputs)
});